import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './awards-marquee.css';

const AWARDS = [
  { id: 'financialAlgorithm', image: 'financial-algorithm-leader' },
  { id: 'asiaPacificGold', image: 'asia-pacific-gold-trading' },
  { id: 'preciousMetals', image: 'precious-metal-credible-brand' },
  { id: 'digitalFinance', image: 'digital-finance-innovation' },
  { id: 'quantitativeTrading', image: 'quantitative-trading-excellence' },
] as const;

export default function AwardsMarquee() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="home-awards awards_marquee_wrapper"
      aria-labelledby="home-awards-title"
      data-visible={visible}
      data-paused={paused}
    >
      <h2 id="home-awards-title" className="sr-only">{t('home.awards.title')}</h2>
      <div className="home-awards__inner">
        <button
          type="button"
          className="home-awards__toggle"
          onClick={() => setPaused(value => !value)}
          aria-label={t(paused ? 'home.awards.play' : 'home.awards.pause')}
          aria-pressed={paused}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d={paused ? 'M8 5v14l11-7Z' : 'M6 5h4v14H6zm8 0h4v14h-4z'} />
          </svg>
        </button>
        <div className="home-awards__viewport" tabIndex={0} role="group" aria-label={t('home.awards.title')}>
          {/* Both copies have identical spacing, so one full group is a seamless loop.
              Keep the original bilingual artwork order in every site language. */}
          <div className="home-awards__track" dir="ltr">
            {[false, true].map(duplicate => (
              <ul
                key={String(duplicate)}
                className="home-awards__group"
                aria-hidden={duplicate || undefined}
                role="list"
              >
                {AWARDS.map(award => (
                  <li key={award.id} className="home-awards__item">
                    <img
                      src={`/img/awards/${award.image}.webp`}
                      alt={duplicate ? '' : t(`home.awards.${award.id}`)}
                      loading="eager"
                      decoding="async"
                    />
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
